import React, { Component } from "react";
import { connect } from "react-redux";
import { actions, selectors, service } from "../redux";
import * as cpo from "~/sode/cpo/redux";
import * as oet from "~/sode/oet/redux";
import { Base } from "zina-dogi-react";
import { Redirect } from "react-router-dom";
import { NonSodeDetail } from "../components";
import swal from "sweetalert";

class NonSodeContainer extends Component {
    state = {
        redirect: false,
        oetID: null
    };

    componentDidMount() {
        this.getDetail();
    }

    render() {
        let { cpo, loading, extraProps } = this.props;
        cpo = cpo || {};
        const base_op = {
            className: "cpo_list",
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                { name: "NON SODE Inbox", rel: "/non-sode/" },
                { name: `NON SODE${cpo.hasOwnProperty("non_sode") ? ` #${cpo.non_sode.id}` : ""}` }
            ],
            extraProps,
            loading
        };
        const redirectUrl = `/non-sode/oet/${this.state.oetID}`;
        return (
            <div style={{ height: "100%" }}>
                {this.state.redirect && this.props.location.pathname !== redirectUrl && <Redirect to={redirectUrl} />}
                <Base {...base_op}>
                    <NonSodeDetail
                        cpo={cpo}
                        onStartOET={this.onStartOET}
                        listCircles={this.props.listCircles}
                        onApproveOrReject={this.onApproveOrReject}
                        update={this.getDetail}
                    />
                </Base>
            </div>
        );
    }

    getDetail = () => {
        const { nonSodeID } = this.props.match.params;
        if (nonSodeID) {
            this.props.getById(nonSodeID);
        }
    };

    onApproveOrReject = data => {
        const { cpo } = this.props;
        if (cpo && cpo.non_sode) {
            return service.update_approve_or_reject(cpo.non_sode.id, data).then(() => {
                this.getDetail();
            });
        }
        return Promise.reject();
    };

    onStartOET = (project, circle) => {
        const { startOET, cpo } = this.props;
        // const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
        if (cpo.oet && cpo.oet.id) {
            this.setState({
                redirect: true,
                oetID: cpo.oet.id
            });
        } else {
            startOET(
                cpo.id,
                circle,
                project,
                oet => {
                    this.setState({
                        redirect: true,
                        oetID: oet.id
                    });
                },
                error => {
                    let data = error.response.data;
                    if (Array.isArray(data)) {
                        data = data.join("\n");
                    }
                    swal({
                        title: "Warning",
                        text: data,
                        icon: "warning",
                        button: true
                    });
                }
            );
        }
    };
}

const mapStateToProps = store => ({
    cpo: selectors.nonSodeSelected(store.non_sode),
    loading: selectors.loading(store.non_sode)
});
const mapDispatchToProps = dispatch => ({
    getById: id => dispatch(actions.getById(id)),
    startOET: (cpoRegisterID, circle, project, onOk, onFail) =>
        dispatch(oet.actions.createOetIn(cpoRegisterID, circle, project, onOk, onFail)),
    listCircles: search => dispatch(cpo.actions.listCircles(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(NonSodeContainer);
